const items = [
  "Cuisine de Saison",
  "Élèves en Formation",
  "Produits Locaux",
  "Menu 5 € · 7 €",
  "Ouvert Jeudi & Vendredi",
  "Brasserie Saint-François",
];

export default function Marquee() {
  const doubled = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-gold/20 bg-burgundy py-5" data-testid="marquee-section">
      <div className="marquee-track flex w-max items-center gap-10">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-serif text-xl italic text-cream/90 sm:text-2xl">
              {item}
            </span>
            <span className="text-lg text-gold" aria-hidden>
              ✦
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
